import { render, staticRenderFns } from "./ScorringPopup.vue?vue&type=template&id=f6a5728a&"
import script from "./ScorringPopup.vue?vue&type=script&lang=js&"
export * from "./ScorringPopup.vue?vue&type=script&lang=js&"
import style0 from "./ScorringPopup.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports